'use client'
import { PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";
import { isFilled } from "@prismicio/client";
import Marquee from "react-fast-marquee";


/**
 * @typedef {import("@prismicio/client").Content.ImageSlice} ImageSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ImageSlice>} ImageProps
 * @type {import("react").FC<ImageProps>}
 */
const Image = ({ slice, index, slices }) => {
  const isLast = Array.isArray(slices) && index === slices.length - 1;
  const fallbackAlt = "Image de contenu";
  const textPosition = slice?.primary?.text_position?.[0];
  const verticalClass = textPosition?.vertical ? `items-${textPosition.vertical}` : "items-start";
  const horizontalClass = textPosition?.horizontal ? `text-${textPosition.horizontal}` : "text-left";

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-white mt-2 ${isLast ? "md:pb-10" : ""}`}
    >
      {slice.variation === "default" && (
        <div className="relative">
          {isFilled.image(slice.primary.img) && (
            <PrismicNextImage field={slice.primary.img} alt={slice.primary.img?.alt || fallbackAlt} className="w-full h-auto" />
          )}
        </div>
      )}
      {slice.variation === "imgWithTxtRight" && (
        <div className={`lg:flex ${verticalClass} ${horizontalClass}`}>
          {isFilled.image(slice.primary.img) && (
            <PrismicNextImage field={slice.primary.img} alt={slice.primary.img?.alt || fallbackAlt} className={`w-full lg:w-[${slice.primary.width}%] h-auto`} />
          )}
          {isFilled.richText(slice.primary.text) && (
            <div className={`flex-1 px-4 md:px-10 py-4 md:py-10 lg:py-0 flex flex-col`}>
              <PrismicRichText
                field={slice.primary.text}
                components={{
                  paragraph: ({ children }) => (
                    <p className="font-neue-haas text-lg font-light">{children}</p>
                  ),
                  em: ({ children }) => (
                    <em className="italic">{children}</em>
                  ),
                  strong: ({ children }) => (
                    <strong className="font-medium">{children}</strong>
                  ),
                }}
              />
            </div>
          )}
        </div>
      )}
      {slice.variation === "imgWithTxtLeft" && (
        <div className={`lg:flex ${verticalClass} ${horizontalClass}`}>
          {isFilled.richText(slice.primary.text) && (
            <div className={`flex-1 px-4 md:px-10 py-4 md:py-10 lg:py-0 flex flex-col`}>
              <PrismicRichText
                field={slice.primary.text}
                components={{
                  paragraph: ({ children }) => (
                    <p className="font-neue-haas text-lg font-light">{children}</p>
                  ),
                  em: ({ children }) => (
                    <em className="italic">{children}</em>
                  ),
                  strong: ({ children }) => (
                    <strong className="font-medium">{children}</strong>
                  ),
                }}
              />
            </div>
          )}
          {isFilled.image(slice.primary.img) && (
            <PrismicNextImage field={slice.primary.img} alt={slice.primary.img?.alt || fallbackAlt} className={`w-full lg:w-[${slice.primary.width}%] h-auto`} />
          )}
        </div>
      )}
      {slice.variation === "carrousel" && (
        <div className="relative flex flex-col gap-2">
          {isFilled.group(slice.primary.images) && slice.primary.images.length > 0 && (
            <Marquee
              autoFill
              gradient={false}
              speed={40}
              pauseOnHover={false}
              pauseOnClick={false}
              direction={slice.primary.direction === "droite" ? "right" : "left"}
              className="w-full"
            >
              <div className="flex items-center gap-2 pr-2">
                {slice.primary.images.slice().reverse().map((item, index) => (
                  <div key={index}>
                    {isFilled.image(item.img) && (
                      <PrismicNextImage
                        field={item.img}
                        alt={item.img?.alt || fallbackAlt}
                        className={`${slice.primary.height ? "h-150" : "h-80"} w-auto object-contain`}
                      />
                    )}
                  </div>
                ))}
              </div>
            </Marquee>
          )}
        </div>
      )}
    </section>
  );
};

export default Image;
